import React from 'react';
import Modals from '../Modals';
import TextAreaInput from 'components/Global/TextArea';
import { Button } from 'components/Global';
import { useState } from 'react';
import { useAppContext } from 'components/Context/AppContext';

import { ReactComponent as CarCharterIcon } from 'icons/car-charter-filled-icon.svg';
import { useDispatch } from 'react-redux';
import { rejectOrder } from 'features/orders/actions';
import { trackEvent } from 'utils/analytics';

const CancelExtendCharterModal = () => {
  const dispatch = useDispatch();
  const { setShowCancelExtendCharter, showCancelExtendCharter, showToast, setShowSpinner } = useAppContext();

  const [reason, setReason] = useState('');

  const handleSubmit = async () => {
    // validation
    const validCancelMessage = reason.replace(/\s/g, '').length !== 0;

    // check if not valid return error toast
    if (!validCancelMessage) {
      return showToast({ type: 'error', message: 'Tulis Alasan Penolakan' });
    }

    // reject if form valid
    const payload = {
      transaction_key: showCancelExtendCharter.transaction_key,
      message: reason,
    };

    try {
      setShowSpinner(true);
      trackEvent('order_rejected', {
        order_id: payload.transaction_key,
        source: 'cancel_extend_charter_modal',
        has_reason: Boolean(payload.message),
      });
      await dispatch(rejectOrder(payload)).unwrap();
      showToast({ type: 'success', message: 'Berhasil Menolak Extend' });
      setReason('');
      setShowCancelExtendCharter(false);
    } catch (err) {
      showToast({ type: 'error', message: 'Gagal Menolak Extend!' });
    } finally {
      setShowSpinner(false);
    }
  };

  const closeModalHandler = (state) => {
    setShowCancelExtendCharter({ ...showCancelExtendCharter, show: state });
  };

  return (
    <Modals setState={closeModalHandler}>
      <div className="cancel-extend-charter">
        <header>
          <CarCharterIcon fill="#009EF7" width="25px" height="25px" />
          <h3>Tolak Extend</h3>
        </header>

        <div className="cancel-extend-charter__message">
          <span>Tulis Keterangan</span>
          <TextAreaInput
            className="cancel-extend-charter__textarea"
            style={{ height: '292px' }}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Tulis keterangan penolakan ..."
          />
        </div>

        <div className="cancel-extend-charter__button">
          <Button
            type="button"
            width="165px"
            height="39px"
            variant="primary"
            size="md"
            className="button"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </Modals>
  );
};

export default CancelExtendCharterModal;
